import { createAsyncThunk } from '@reduxjs/toolkit';

import { inGameHistoryData } from '../../api/inGameHistoryData/fetcher';

export const fetchInGameHistoryData = createAsyncThunk(
  'chartsData/fetchInGameHistoryData',
  (params: any) => inGameHistoryData(params)
);
